interface PinIconProps {
    className?: string;
}

// Pushpin / thumbtack drawn to match the Heroicons outline style (24x24,
// 1.5 stroke). Heroicons itself only ships a map-location pin, so the path
// is hand-rolled: head bar, tapering body, stem.
function PinIcon({ className }: PinIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className={className}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 4v6l-2 4v2h10v-2l-2-4V4M12 16v5M8 4h8"
            />
        </svg>
    );
}

export { PinIcon };
